import axios from "axios"
import baseUrl from "./base"

const authApi = {
  registerPenduduk: async (data) => {
    return await axios.post(`${baseUrl}/api/register`, data)
  },
  sendLinkEmailVerification: async (token, data) => {
    return await axios.post(`${baseUrl}/api/email/verification-notification`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  verifyLinkEmailVerification: async (token, data) => {
    return await axios.post(`${baseUrl}/api/email/verify/${data.id}/${data.hash}`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  loginUser: async (data) => {
    return await axios.post(`${baseUrl}/api/login`, data)
  },
  loginUserByDeveloper: async (data) => {
    return await axios.post(`${baseUrl}/api/loginByDeveloper`, data)
  },
  logoutUser: async (token) => {
    return await axios.post(`${baseUrl}/api/logout`, null,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchCaptcha: async (id) => {
    return await axios.get(`${baseUrl}/api/captcha/${id}`)
  },
}

export default authApi